<template>
  <figure class="wrapper m-d">
    <div id="carrot-jump" class="advergaming-minigame carrot-jump">
      <Counter :score="score" />
      <Transition @leave="onOverlayLeave">
        <GameOverlay v-if="!hideOverlay" mobile="none" desktop="keys" />
      </Transition>
    </div>

    <div class="advergaming-buttons">
      <button
        class="advergaming-buttons__button--left jsleft"
        @touchstart="onPointer('ArrowLeft', true)"
        @touchcancel="onPointer('ArrowLeft', false)"
        @touchend="onPointer('ArrowLeft', false)"
      >
        <div class="advergaming-buttons__button__inner">
          <SvgSprite
            symbol="ui-advergaming-overlay-arrow-key"
            size="19 21"
            class="advergaming-buttons__button__arrow"
          />
        </div>
      </button>
      <button
        class="advergaming-buttons__button--right jsright"
        @touchstart="onPointer('ArrowRight', true)"
        @touchcancel="onPointer('ArrowRight', false)"
        @touchend="onPointer('ArrowRight', false)"
      >
        <div class="advergaming-buttons__button__inner">
          <SvgSprite
            symbol="ui-advergaming-overlay-arrow-key"
            size="19 21"
            class="advergaming-buttons__button__arrow"
          />
        </div>
      </button>
    </div>

    <Caption :content="content" />
  </figure>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, PropType, watch } from 'vue'
import { useStore } from '@nanostores/vue'

import { CarrotJump } from './CarrotJump'
import Counter from '@/components/advergaming/Counter.vue'
import Caption from '@/components/advergaming/Caption.vue'
import GameOverlay from '@/components/advergaming/GameOverlay.vue'
import { useAdvergamingStore } from '@/stores/advergaming'
import { AdvergamingCaption } from '@/components/advergaming/Caption.vue'
import gsap from 'gsap'

defineProps({
  content: {
    type: Object as PropType<AdvergamingCaption>,
    required: true,
  },
})

const game = new CarrotJump({
  id: 'carrot-jump',
  store: useAdvergamingStore(),
})

const hideOverlay = useStore(game.store.$interactedWith)
const onOverlayLeave = (el: Element, done: () => void) => {
  gsap.to(el, {
    opacity: 0,
    scale: 1.1,
    duration: 0.15,
    onComplete: done,
  })
}

const score = useStore(game.store.$score)

onMounted(() => {
  game.init({
    container: document.querySelector('#carrot-jump')!,
    renderer: {
      antialias: true,
    },
  })
})

onBeforeUnmount(() => {
  game?.dispose()
})

const onPointer = (keyCode: 'ArrowLeft' | 'ArrowRight', isDown: boolean) => {
  if (!game) {
    return
  }

  game.keys[keyCode].isDown = isDown
  game.keys[keyCode].isJustDown = isDown
  game.store.$interactedWith.set(true)
}
</script>

<style lang="scss" scoped>
.carrot-jump {
  @include mq($until: m) {
    height: 65vh;
  }
}
</style>
